/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useCallback } from "react";
import { useFileUpload } from "use-file-upload";
import useState from "react-usestateref";
import {
  ArrowLeftIcon,
  XIcon,
  PencilIcon,
  DotsVerticalIcon,
} from "@heroicons/react/solid";
import { Navigate, useNavigate } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import backendService from "../services.js/backendService";
import toastProp from "../global/toastProps";
import ImageViewer from "react-simple-image-viewer";
import { toast } from "react-toastify";
import axios from "axios";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function EditProfileScreen() {
  const navigate = useNavigate();

  const [file, selectFile] = useFileUpload();
  const [profilePictureAreaState, setProfilePictureAreaState] = useState(false);
  const [changePasswordAreaState, setChangePasswordAreaState] = useState(false);
  const [usernameAreaState, setUsernameAreaState] = useState(false);
  const [description, setDescriptionAreaState] = useState(false);
  const [descriptionText, setDescriptionText, descriptionTextRef] = useState(
    backendService.getLoggedInUser()["description"]?.length > 0
      ? backendService.getLoggedInUser()["description"]
      : ""
  );
  const [usernameText, setUsernameText, usernameTextRef] = useState(
    backendService.getLoggedInUser()["name"]
  );
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword, newPasswordRef] = useState("");
  const [confirmPassword, setConfirmPassword, confirmPasswordRef] =
    useState("");
  const [passwordIsValid, setPasswordIsValid, passwordIsValidRef] =
    useState(true);
  const [
    confirmPasswordIsValid,
    setConfirmPasswordIsValid,
    confirmPasswordIsValidRef,
  ] = useState(true);
  const [token, setToken] = useState(backendService.getToken());
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const [usernameIsValid, setUsernameIsValid, usernameIsValidRef] =
    useState(true);
  const [descriptionValid, setDescriptionValid, descriptionValidRef] =
    useState(true);
  const [isLogged, setisLogged] = useState(backendService.isLoggedIn());
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [editProfileSection, setEditProfileSection] = useState(true);

  const openImageViewer = useCallback(() => {
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setIsViewerOpen(false);
  };

  const getProfilePicture = async () => {
    const response = await axios.get(`${process.env.REACT_APP_URL}/getProfilePicture`, {
      headers: { "x-auth-token": token },
    });
    setProfilePictureUrl(response.data);
  };
  useEffect(() => {
    getProfilePicture();
  }, [profilePictureUrl]);
  const passwordValidation = () => {
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&()*^%~{}=+-_]{8,}$/i;
    if (passwordRegex.test(newPasswordRef.current)) {
      setPasswordIsValid(true);
    } else {
      setPasswordIsValid(false);
    }
  };
  const confirmPasswordValidation = () => {
    if (newPasswordRef.current === confirmPasswordRef.current) {
      setConfirmPasswordIsValid(true);
    } else {
      setConfirmPasswordIsValid(false);
    }
  };
  const handlePass = async (e) => {
    if (
      password.length !== 0 &&
      newPassword.length !== 0 &&
      confirmPassword.length !== 0
    ) {
      e.preventDefault();
      const id = toast.loading("Please wait...");
      try {
        toast.update(id, {
          render: "Changing password...",
          isLoading: true,
          theme: "light",
        });
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/changepass`,
          JSON.stringify({ newpassword: newPassword, oldpassword: password }),
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": token,
            },
          }
        );
        toast.update(id, toastProp("Password changed successfully", true));
        backendService.logout();
        navigate("/");
       

      } catch (error) {
        toast.update(id, toastProp(error.response.data["Status"], false));
        console.log(error.response);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  const handleUsername = async (e) => {
    if (usernameText !== backendService.getLoggedInUser()["name"]) {
      const id = toast.loading("Please wait...");
      try {
        toast.update(id, {
          render: "Changing username...",
          isLoading: true,
          theme: "light",
        });
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/changedetails`,
          JSON.stringify({
            username: usernameTextRef.current,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": token,
            },
          }
        );
        toast.update(id, toastProp("Details changed successfully", true));
        localStorage.setItem("token", response.data.Token);
        window.location.reload(false);
     
      } catch (error) {
        toast.update(id, toastProp(error.response.data["Status"], false));
        console.log(error.response);
      }
    } else {
      toast.error("Username must be change from the current one", {
        theme: "light",
      });
    }
  };
  const handleDescription = async (e) => {
    if (descriptionTextRef.current.length !== 0) {
      const id = toast.loading("Please wait...");
      try {
        toast.update(id, {
          render: "Changing description...",
          isLoading: true,
          theme: "light",
        });
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/changedetails`,
          JSON.stringify({
            description: descriptionTextRef.current,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": token,
            },
          }
        );
        toast.update(id, toastProp("Details changed successfully", true));
        localStorage.setItem("token", response.data.Token);
        window.location.reload(false);
       
      } catch (error) {
        toast.update(id, toastProp(error.response.data["Status"], false));
        console.log(error.response);
      }
    }
  };

  const saveChanges = async (e) => {
    if (usernameIsValidRef.current && descriptionValidRef.current) {
      const id = toast.loading("Please wait...");
      try {
        toast.update(id, {
          render: "Saving changes...",
          isLoading: true,
          theme: "light",
        });
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/changedetails`,
          JSON.stringify({
            username:
              usernameTextRef.current ===
              backendService.getLoggedInUser()["name"]
                ? ""
                : usernameTextRef.current,
            description: descriptionTextRef.current,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": token,
            },
          }
        );
        toast.update(id, toastProp("Details changed successfully", true));
        localStorage.setItem("token", response.data.Token);
        window.location.reload(false);
        
      } catch (error) {
        toast.update(id, toastProp(error.response.data["Status"], false));
        console.log(error.response);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  const removeProfilePicture = async () => {
    const id = toast.loading("Please wait...");
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/removeProfilePicture`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": token,
          },
        }
      );
      toast.update(id, toastProp("Profile picture removed successfully", true));
      localStorage.setItem("token", res.data.Token);
      window.location.reload(false);
    } catch (error) {
      toast.update(id, toastProp(error.response.data["Status"], false));
      console.log(error.response);
    }
  };

  const usernameValidation = () => {
    const usernameRegex = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/i;
    if (
      usernameRegex.test(usernameTextRef.current) &&
      usernameTextRef.current.length >= 3
    ) {
      setUsernameIsValid(true);
    } else {
      setUsernameIsValid(false);
    }
  };
  const descriptionValidation = () => {
    if (
      descriptionTextRef.current.length >= 10 &&
      descriptionTextRef.current.length <= 300
    ) {
      setDescriptionValid(true);
    } else {
      setDescriptionValid(false);
    }
  };

  return (
    <>
      {!isLogged ? (
        <Navigate replace to="/" />
      ) : (
        <>
          {isViewerOpen && (
            <ImageViewer
              src={[profilePictureUrl]}
              currentIndex={0}
              onClose={closeImageViewer}
              backgroundStyle={{
                backgroundColor: "rgba(0,0,0,0.9)",
              }}
            />
          )}
          <div className="h-screen  bg-background flex justify-center">
            {editProfileSection ? (
              <div className=" flex shadow-md shadow-black m-[3%] rounded-lg px-5 justify-center items-center">
                <div>
                  <div className="flex justify-center items-center text-2xl mb-3">
                    {/* <ArrowLeftIcon
                className="h-6 w-6 text-primary cursor-pointer"
                aria-hidden="true"
                onClick={() => navigate(-1, { replace: true })}
              /> */}
                    <h3 className="font-robo  antialiased text-primary text-2xl ">
                      Edit Profile
                    </h3>
                  </div>
                  {file || profilePictureUrl ? (
                    <div className="flex justify-center items-center  w-[100%]">
                      <img
                        alt="Profile"
                        className="rounded-full h-44 w-44 cursor-pointer"
                        onClick={() => openImageViewer()}
                        src={profilePictureUrl}
                      />
                    </div>
                  ) : (
                    <div className="flex justify-center items-center  w-[100%]">
                      <span className="inline-block h-44 w-44 rounded-full overflow-hidden bg-card">
                        <svg
                          className="h-full w-full text-secondary"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                      </span>
                    </div>
                  )}

                  <div className="flex w-full justify-center items-center">
                    <button
                      type="button"
                      className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-6 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                      onClick={() => {
                        selectFile(
                          { accept: "image/*" },
                          ({ source, name, size, file }) => {
                            const id = toast.loading("Uploading ...", {
                              theme: "light",
                            });
                            const formData = new FormData();
                            formData.append("file", file);
                            axios
                              .post(
                                `${process.env.REACT_APP_URL}/uploadProfilePicture`,
                                formData,
                                {
                                  headers: {
                                    "Content-Type": "multipart/form-data",
                                    "x-auth-token": token,
                                  },
                                }
                              )
                              .then((res) => {
                                getProfilePicture();
                                localStorage.setItem("token", res.data.Token);
                                toast.update(id, toastProp("Uploaded", true));
                                window.location.reload(false);
                              })
                              .catch((err) => {
                                toast.update(
                                  id,
                                  toastProp("Upload Failed", false)
                                );
                              });
                          }
                        );
                      }}
                    >
                      {!file ? "Upload" : "Uploading ..."}
                    </button>
                    <Menu as="div" className="relative inline-block text-left ">
                      <div>
                        <Menu.Button>
                          <DotsVerticalIcon
                            className=" mt-1  w-5 text-palette_color1"
                            aria-hidden="true"
                          />
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-md shadow-black bg-palette_color2 focus:outline-none">
                          <Menu.Item>
                            {({ active }) => (
                              <a
                              
                                className={classNames(
                                  active
                                    ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                    : "text-palette_color1",
                                  "block px-4 py-2 text-sm font-robo "
                                )}
                                onClick={() => {
                                  setChangePasswordAreaState(false);
                                  // setProfilePictureAreaState(true);
                                  openImageViewer();
                                }}
                              >
                                View Photo
                              </a>
                            )}
                          </Menu.Item>
                          {profilePictureUrl && (
                          <Menu.Item>
                            {({ active }) => (
                              <a
                               
                                className={classNames(
                                  active
                                    ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                                    : "text-palette_color1",
                                  "block px-4 py-2 text-sm font-robo "
                                )}
                                onClick={async () => {
                                  await removeProfilePicture();
                                  window.location.reload(false);
                                }}
                              >
                                Remove Photo
                              </a>
                            )}
                          </Menu.Item>)}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                  <div className="flex">
                    <div className="w-full">
                      <div className="flex justify-between items-center ">
                        <h3 className="block text-lg font-robo text-primary">
                          Username
                        </h3>
                      </div>
                      <input
                        id="username"
                        name="username"
                        autoComplete="off"
                        // disabled={usernameAreaState ? false : true}
                        className="appearance-none rounded block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10  sm:text-sm"
                        placeholder={
                          usernameAreaState
                            ? "Enter new username"
                            : backendService.getLoggedInUser()["name"]
                        }
                        aria-hidden="true"
                        value={usernameText}
                        onChange={(e) => {
                          setUsernameText(e.target.value);
                          usernameValidation();
                        }}
                      />
                      <div className="flex items-center justify-start">
                        {!usernameIsValidRef.current ? (
                          <h3 className="text-sm justify-self-start text-red font-robo ">
                            * Enter a valid username
                          </h3>
                        ) : null}
                      </div>

                      <div className="flex justify-between items-center  ">
                        <h3 className="block text-lg font-robo text-primary ">
                          About
                        </h3>
                      </div>
                      <textarea
                        id="about"
                        name="about"
                        // disabled={description ? false : true}
                        rows={3}
                        className="appearance-none rounded block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm resize-none"
                        placeholder={
                          !backendService.getLoggedInUser()["description"]
                            ?.length > 0
                            ? "Enter new description"
                            : backendService.getLoggedInUser()["description"]
                        }
                        value={descriptionText}
                        onChange={(e) => {
                          setDescriptionText(e.target.value);
                          descriptionValidation();
                        }}
                      />
                      <div className="flex justify-start">
                        {!descriptionValidRef.current ? (
                          <h3 className="text-xs  text-red font-robo  ">
                            *Minimum 10 characters, Maximum 300 characters
                          </h3>
                        ) : null}
                      </div>
                      <div className="flex justify-end items-center py-1">
                        <button
                          type="button"
                          className="bg-palette_color1 mt-1  border-[1px] border-palette_color1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-6 py-1 rounded shadow-sm hover:border hover:border-palette_color1 hover:shadow-lg  ml-1  ease-linear transition-all duration-500"
                          onClick={async () => {
                            await saveChanges();
                          }}
                        >
                          Save Changes
                        </button>
                        
                      </div>

                      <div className="flex justify-between items-center ">
                        <h3 className="block text-md font-robo text-primary ">
                          Want to change your password?{" "}
                          <span
                            className="font-robo  text-md hover:underline text-palette_color1 cursor-pointer"
                            onClick={() => {
                              setChangePasswordAreaState(true);
                              setEditProfileSection(false);
                              // setProfilePictureAreaState(false);
                            }}
                          >
                            Click here
                          </span>
                        </h3>
                        {/* <div className="py-5 text-right">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-lg font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none"
                      onClick={() => {
                        if (usernameIsValid && descriptionValid) {
                          handleDetails();
                        }
                      }}
                    >
                      Save
                    </button>
                  </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {/* View full profile picture */}
            {/* {profilePictureUrl && profilePictureAreaState ? (
            <div className="bg-white shadow-2xl rounded-2xl p-[3%] w-[50%] m-5">
              <XIcon
                className="h-5 w-5 text-black cursor-pointer"
                aria-hidden="true"
                onClick={() => setProfilePictureAreaState(false)}
              />
              <div className="flex justify-center items-center m-2 p-[4%]">
                <img
                  alt="Profile"
                  className="h-[70vh]"
                  src={profilePictureUrl}
                />
                <div className="h-[40vh]"></div>
              </div>
            </div>
          ) : null} */}
            {/* Change Password */}
            {changePasswordAreaState ? (
              <div className="flex justify-center items-center">
                <div>
                  <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                    <ArrowLeftIcon
                      className="h-5 w=5"
                      aria-hidden="true"
                      onClick={() => {
                        setChangePasswordAreaState(false);
                        setEditProfileSection(true);
                      }}
                    />
                  </div>

                  <h2 className="font-robo text-primary  text-center text-4xl mt-1">
                    Change Password
                  </h2>
                  <form action="#" method="POST">
                    <div className="col-span-6 sm:col-span-3 h-80">
                      <div className="w-[100%]">
                        {/* Current Password Input */}
                        <label className="block text-md font-robo text-primary  mt-3">
                          Current Password
                          <span className="text-red"> *</span>
                        </label>
                        <input
                          type="password"
                          name="current-password"
                          id="current-password"
                          required
                          className="appearance-none border-[1px] border-palette_color1 rounded relative block w-full px-3 py-2  bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                          placeholder="Enter current Password"
                          onChange={(e) => setPassword(e.target.value)}
                          // onBlur={() => passwordValidation()}
                          //   onChange={(e) => setPassword(e.target.value)}
                        />
                        {/* New Password Input */}
                        <label className="block text-md font-robo text-primary  mt-3">
                          New Password
                          <span className="text-red"> *</span>
                        </label>
                        <input
                          type="password"
                          name="newPassword"
                          id="newPassword"
                          required
                          className="appearance-none border-[1px] border-palette_color1 rounded relative block w-full px-3 py-2  bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                          placeholder="New Password"
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                            passwordValidation();
                          }}
                        />
                        {/* Implement logic on h3 to show/hide error message */}
                        {!passwordIsValidRef.current ? (
                          <h3 className="text-sm text-red font-robo  ">
                            * Password must have atleast 8 characters,
                            <br /> atleast 1 number and 1 letter
                          </h3>
                        ) : null}
                        {/* Confirm Password Input */}
                        <label className="block text-md font-robo text-primary  mt-3">
                          Confirm Password
                          <span className="text-red"> *</span>
                        </label>
                        <input
                          type="password"
                          name="confirm-newPassword"
                          id="confirm-newPassword"
                          required
                          className="appearance-none border-[1px] border-palette_color1 rounded relative block w-full px-3 py-2  bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                          placeholder="Confirm Password"
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            confirmPasswordValidation();
                          }}
                        />
                        {!confirmPasswordIsValidRef.current ? (
                          <h3 className="text-sm  text-red font-robo ">
                            * Password must be same
                          </h3>
                        ) : null}
                        <div className="py-1 text-right">
                          <button
                            type="submit"
                            className="bg-palette_color1 border-[1px] border-palette_color1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-3 py-1 rounded shadow-sm hover:border hover:border-palette_color1 hover:shadow-lg  mr-1 mb-1 ease-linear transition-all duration-500"
                            onClick={async (e) => {
                              if (
                                passwordIsValidRef.current &&
                                confirmPasswordIsValidRef.current
                              ) {
                                await handlePass(e);
                              } else {
                                e.preventDefault();
                              }
                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            ) : null}
          </div>
        </>
      )}
    </>
  );
}

export default EditProfileScreen;
